function wm_set_scroll_padding(elem) {
    let html = document.documentElement;
    let headerHeight = elem.offsetHeight;
    let headerPos = elem.getBoundingClientRect().top;
    headerHeight += headerPos;
    html.style.setProperty('--scroll-padding', `${headerHeight}px`);
}

function wm_header_resize() {
    let header = document.querySelector('.header');

    if (!header) return;

    wm_set_scroll_padding(header);

    let observer = new ResizeObserver(([entry]) => {
        wm_set_scroll_padding(entry.target);
    });

    observer.observe(header);
}

document.addEventListener('DOMContentLoaded', () => {
    wm_header_resize();
});
